import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { LicenseService } from '../../license/services/license.service';
import { LogOut } from '../store/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class LicenseInvalidGuard implements CanActivate {
  constructor(
    private licenseService: LicenseService,
    private router: Router,
    private store: Store
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      // Verificar permisos de licencia de forma asíncrona como en appHasPermission
      const existingPermissionList = localStorage.getItem('PermissionList');
      if (!existingPermissionList) {
        console.log('(LICENSE) no tiene permisos en el localstorage page');
        return this.router.createUrlTree(['']);
      }
      const content: string[] = JSON.parse(existingPermissionList ?? '[]');
      if (!content.some((permission) => permission === 'license_module')) {
        console.log(
          '(LICENSE) no tiene permisos habilitados este usuario page'
        );
        return this.router.createUrlTree(['']);
      }

      const response = await this.licenseService.checkLicensePublic();

      if (response.isLicenseValid && response.remainingTime > 0) {
        // Si la licencia es válida, redirigir al login
        return this.router.createUrlTree(['']);
      } else {
        // Si la licencia es inválida, permitir acceso a la página de licencia y limpiar el localStorage y store
        localStorage.clear();
        this.store.dispatch(new LogOut());
        return true;
      }
    } catch (err) {
      // En caso de error, redirigir al login
      return this.router.createUrlTree(['']);
    }
  }
}
